import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTemplateIconProps extends SvgIconProps {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfTemplateIcon(props: CcfTemplateIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9409 9V17C17.9409 17.5 17.5422 18 16.7449 18H2.89048C2.59147 18 1.99344 17.5 1.99344 17V3C1.99344 2.5 2.59147 2 3.1895 2H9.96718V0H3.1895C0.996718 0 0 1.1 0 3.1V17C0 18.6 0.996718 20 3.08982 20H16.6452C18.7383 20 19.9344 19 19.9344 17V9H17.9409ZM13.1567 7H18.9376C20.2334 7 20.1337 6.3 19.735 6L12.9573 0.1C12.459 -0.2 11.9606 0.4 11.9606 0.8V6C11.9606 6.2 11.9606 7 13.1567 7ZM9.1698 7.6C8.87079 7.3 8.37243 7.3 8.07341 7.6L6.07998 9.5L5.18293 8.6C4.88392 8.3 4.38556 8.3 4.08654 8.6C3.8872 8.7 3.78753 8.9 3.78753 9.1C3.78753 9.3 3.8872 9.5 3.98687 9.6L5.48195 11C5.68129 11.1 5.88063 11.2 6.07998 11.2C6.27932 11.2 6.47867 11.1 6.67801 11L9.1698 8.6C9.46882 8.4 9.46882 7.9 9.1698 7.6ZM4.18621 14.5C4.18621 15.3 4.88392 16 5.78096 16C6.67801 16 7.37571 15.3 7.37571 14.5C7.37571 13.7 6.67801 13 5.78096 13C4.88392 13 4.18621 13.7 4.18621 14.5ZM15.9475 9H9.96718V11H15.9475V9ZM9.96718 15H15.9475V13H9.96718V15Z"
        fill="#3F5C69"
      />
    </SvgIcon>
  );
}

export default CcfTemplateIcon;
